import React from 'react';
import Input from '../../../../components/forms/Input';
import TextArea from '../../../../components/forms/TextArea';
import KeyValueInputGroup from '../../../../components/forms/KeyValueInputGroup';
import { phoneTypeOptions, socialMediaOptions } from '../../../../selectors/admin/models/contacts';
import PictureHeader from '../PictureHeader';
import SelectField from '../../../forms/SelectField';
import { toSelectionFormat } from '../../../../lib/collection.utils';

const ContactInputs = ({
    data,
    errors,
    onInput,
    withContext,
    context,
    contextOptions,
    onKeyValueInput,
    onKeyValueDelete,
    dependencies
}) => (
    <React.Fragment>
        <PictureHeader nameField="fullName" nameLabel="Full Name *" data={data} errors={errors} onInput={onInput} />
        <div className="ckp-admin-forms-body">
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column">
                    <SelectField
                        multiple={true}
                        disabled={withContext}
                        items={contextOptions}
                        label="Organizations"
                        onChange={onInput}
                        name="organizationIds"
                        value={withContext ? [context] : data.organizationIds}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <SelectField
                        items={toSelectionFormat(dependencies.partners)}
                        label="Media Partners"
                        onChange={onInput}
                        name="partnerIds"
                        multiple={true}
                        value={data.partnerIds}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <SelectField
                        items={toSelectionFormat(dependencies.artists)}
                        label="Artist Groups"
                        onChange={onInput}
                        name="artistIds"
                        multiple={true}
                        value={data.artistIds}
                    />
                </div>
            </div>
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column is-1-3">
                    <Input
                        errorMessage={errors.email}
                        label="Email *"
                        name="email"
                        className="is-full-width"
                        onChange={(e, f) => onInput(e.toLowerCase(), f)}
                        value={data.email}
                    />
                    {
                        <KeyValueInputGroup
                            name="phones"
                            keyLabel="Phone"
                            valueLabel="Number"
                            onKeyValueInput={onKeyValueInput}
                            options={phoneTypeOptions}
                            group={data.phones}
                            onDelete={onKeyValueDelete}
                        />
                    }
                    {
                        <KeyValueInputGroup
                            name="socialMedia"
                            keyLabel="Social Media"
                            valueLabel="URL"
                            onKeyValueInput={onKeyValueInput}
                            options={socialMediaOptions}
                            group={data.socialMedia}
                            onDelete={onKeyValueDelete}
                        />
                    }
                    <Input
                        className="is-full-width"
                        errorMessage={errors.website}
                        label="Website"
                        name="website"
                        onChange={onInput}
                        value={data.website}
                    />
                </div>
                <div className="ckp-admin-grid-column is-2-3">
                    <TextArea label="Note" name="note" onChange={onInput} value={data.note} />
                </div>
            </div>
        </div>
    </React.Fragment>
);

export default ContactInputs;
